import { Routes, Route } from "react-router-dom";
import { routerPath } from "./path";
import Login from "../pages/onboarding/screens/login";
import PurchasePlan from "../pages/onboarding/screens/purchase-plan";

const OnboardRoutes = () => {
	return (
		<Routes>
			<Route path="/" element={<Login />}></Route>
			<Route path={routerPath.Login} element={<Login />}></Route>
			<Route path={routerPath.purchasePlan} element={<PurchasePlan />}></Route>
			<Route path="*" element={<Login />}></Route>
		</Routes>
	);
};

export default OnboardRoutes;
